module.exports = __webpack_public_path__ + "static/media/xfinity-sell-eng.025e4c2e.png";